import { useState } from 'react';
import Button from './Button';
import Input from './Input';
import clsx from 'clsx';

export interface IClipBoard {
  copyText: string;
  buttonSecondary?: boolean;
  label?: string;
}
function ClipboardCopy({ copyText, buttonSecondary, label }: IClipBoard) {
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text: string) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 3000);
      })
      .catch(() => {});
  };

  return (
    <div className="flex items-center justify-between gap-2">
      <Input
        disabled
        label={label}
        type="text"
        value={copyText}
        className="border border-primary-main "
      />
      <>
        <Button
          label={isCopied ? 'Copied!' : 'Copy'}
          curved
          size="md"
          bgColor={buttonSecondary ? 'secondary' : 'primary'}
          onClick={handleCopyClick}
          className={clsx(
            ' w-fit px-5 h-11',
            buttonSecondary && 'hover:bg-primary-main',
            label && 'mt-6'
          )}></Button>
      </>
    </div>
  );
}

export default ClipboardCopy;
